module.exports = __webpack_public_path__ + "img/rate_app.fafa39ec.svg";